export const SELECT_BASE_PACK = 'SELECT_BASE_PACK';
export const SELECT_BASE_OPTION = 'SELECT_BASE_OPTION';
export const SELECT_ADD_ON = 'SELECT_ADD_ON'

export const REMOVE_BASE_PACK = 'REMOVE_BASE_PACK';
export const REMOVE_BASE_OPTION = 'REMOVE_BASE_OPTION';
export const REMOVE_ADD_ON = 'REMOVE_ADD_ON';